'use strict';
var parent = require('../../es/symbol/to-primitive');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/symbol/to-primitive.js
// module id = 784
// module chunks = 13